// Plate nodes are open records; the index signature keeps this assignable to
// Plate's deserializer node type without a cast.
export interface DeserializedImageNode {
  type: string;
  url: string | null;
  width?: string | number;
  height?: string | number;
  [key: string]: unknown;
}

// Reads a size from the img attribute or inline style: `%` kept verbatim,
// px/unitless normalized to a unitless number so serialization stays valid.
export function readImgDimension(
  element: HTMLElement,
  name: "width" | "height",
): string | number | undefined {
  const raw =
    element.getAttribute(name) ?? element.style.getPropertyValue(name);
  const trimmed = raw?.trim();
  if (!trimmed) {
    return undefined;
  }
  if (trimmed.endsWith("%")) {
    return trimmed;
  }
  const parsed = Number.parseFloat(trimmed);
  return Number.isNaN(parsed) ? undefined : parsed;
}

// Pure `parse` half of the image HTML deserializer (editor-plugins.ts supplies
// `rules`). Plate's stock deserializer reads only `src`, dropping size (HELP-460).
export function parseImageNode({
  element,
  type,
}: {
  element: HTMLElement;
  type: string;
}): DeserializedImageNode {
  const width = readImgDimension(element, "width");
  const height = readImgDimension(element, "height");
  return {
    type,
    url: element.getAttribute("src"),
    ...(width !== undefined ? { width } : {}),
    ...(height !== undefined ? { height } : {}),
  };
}
